import { useContext } from "react";

import { KeyboardNavigationContext, KeyboardNavigationContextType } from "./KeyboardNavigationContext";

export const useKeyboardNavigationContext = (): KeyboardNavigationContextType => {
    const context = useContext(KeyboardNavigationContext);
    if (!context) {
        throw new Error("Context cannot be empty. Check if your component is wrapped in KeyboardNavigationContextProvider");
    }
    return context;
};
